import { ErrorInfo, Component, ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallBackUI: ReactNode
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  // Update state so the next render will show the fallback UI.
  static getDerivedStateFromError() {
    return { hasError: true }
  }

  // You can also log the error to an error reporting service
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // console.log(error, errorInfo)
  }

  render() {
    const { hasError } = this.state
    const { fallBackUI } = this.props
    if (hasError) { // You can render any custom fallback UI
      return (
        fallBackUI
      )
    }
    const { children } = this.props

    return children
  }
}
